import VueStripeCheckout from './dist';

export default VueStripeCheckout;


//////////////////
// WEBPACK FOOTER
// ./~/vue-stripe-checkout/index.js
// module id = 272
// module chunks = 0